<template>
  <div>
  </div>
    
</template>
<script>
export default {
  props: {
    bounds: {
      type: Object,
      required: true
    },
    transform: {
      type: Object,
      required: true
    },
    parentTransform: {
      type: Object,
      required: true
    },
    holder: {
      type: Object,
      required: true
    },
    addTarget: {
      type: Function,
      required: true
    },
    removeTarget: {
      type: Function,
      required: true
    },
    updateTarget: {
      type: Function,
      required: true
    },
    updateContainerBounds: {
      type: Function,
      required: true
    },
    indirectlySelected: {
      type: Boolean,
      required: true
    }
  },
  mounted() {
    this.addTarget({
      transform:this.transform,
      bounds:this.bounds,
      updateContainerBounds:this.updateContainerBounds,
      indirectlySelected:this.indirectlySelected,
      holder:this.holder,
      key:this.parentTransform.id + '-' + this.transform.id
    });
  },
  beforeDestroy() {
    this.removeTarget({
      transform:this.transform,
      key:this.parentTransform.id + '-' + this.transform.id
    });
  },
  watch:{
    indirectlySelected(nv) {
      const key = this.parentTransform.id + '-' + this.transform.id;
      this.updateTarget(key, {
        indirectlySelected:nv
      });
    },
  }
}
</script>
